app.controller(
    'AppController', ['$scope', '$rootScope', 'Configuration', 'UserService', '$stateParams', 'HelperService', '$window', '$timeout', 'AuthenticationService', '$state', '$location', '$sce', '$translate', 'toastr', 'filterFilter', AppController]
);

var globalEnumRole = {
    SuperAdmin: 1,
    Admin: 2,
    Author: 3,
    Corrector: 4,
    Translator: 5,
    SecretaryEditor: 6,
    ConsultationOnly: 7   //Lecture
};

var globalRoleForPagesConsultation = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.Author, globalEnumRole.Corrector, globalEnumRole.Translator, globalEnumRole.SecretaryEditor];
var globalRoleForPagesCorrection = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.Author, globalEnumRole.Corrector, globalEnumRole.SecretaryEditor];
var globalRoleForPagesTranslation = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.Translator, globalEnumRole.SecretaryEditor];
var globalRoleForPagesCreation = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.Author, globalEnumRole.SecretaryEditor];
var globalRoleForPagesAdmin = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.SecretaryEditor];
var globalRoleForDownload = [globalEnumRole.SuperAdmin, globalEnumRole.Admin];
var globalRoleForResendMailWelcome = [globalEnumRole.SuperAdmin, globalEnumRole.Admin];
var globalRoleForDragAndDropPosition = [globalEnumRole.SuperAdmin, globalEnumRole.Admin, globalEnumRole.Author, globalEnumRole.Corrector, globalEnumRole.SecretaryEditor];



function showlog(o) {
    if (activeLog) {
        console.log(o);
    }
}


function AppController($scope, $rootScope, Configuration, UserService, $stateParams, HelperService, $window, $timeout, AuthenticationService, $state, $location, $sce, $translate, toastr, filterFilter) {

    $rootScope.interfaceSubFolder = Configuration.interfaceSubFolder.url;
    $rootScope.assetUrlImg = Configuration.assets.url + 'img/'; // assets url for img

    $rootScope.diffoptions = {
        editCost: 6,
        //interLineDiff: true,
        //ignoreTrailingNewLines: true,
        attrs: {
            insert: {
                'class': 'txt-green'
            },
            delete: {
                'class': 'txt-error'
            },
            equal: {

            }
        }
    };


    $scope.$on(
        '$viewContentLoaded',
        function () {
            // dropdown();
            menu();
            //!  scrollAnchor();
            //tabs();
        });

    $scope.CurrentLang = 'fr';

    $rootScope.LangForInterface = $rootScope.globals.currentUser.LangForInterface;
    $rootScope.LangForWork = $rootScope.globals.currentUser.LangForWork;
    $rootScope.LangForTranslationSource = $rootScope.globals.currentUser.LangForTranslationSource;
    $rootScope.LangForTranslationDestination = $rootScope.globals.currentUser.LangForTranslationDestination;

    $scope.GlobalDebounce = 2000; //mili-seconds    


    if ($rootScope.LangForInterface == 'fr') {
        $rootScope.GlobalDateFormatForDisplay = 'dd/MM/yyyy';
        $rootScope.GlobalDateFormatForDisplayWithTime = 'dd/MM/yyyy - HH:mm';
    }
    else {
        $rootScope.GlobalDateFormatForDisplay = 'MM/dd/yyyy';
        $rootScope.GlobalDateFormatForDisplayWithTime = 'MM/dd/yyyy - HH:mm';
    }
    $rootScope.GlobalDateFormatForMomentDatePicker = "yy-mm-dd";
    $rootScope.GlobalDateFormatForDatePicker = 'yyyy-MM-dd';

    $rootScope.response = {
        success: false,
        error: false,
        loading: false
    };

    $rootScope.ShowIconNormal = function () {
        $rootScope.response.loading = false;
        $rootScope.response.success = false;
        $rootScope.response.error = false;
    };
    $rootScope.ShowIconLoading = function () {
        $rootScope.response.loading = true;
        $rootScope.response.success = false;
        $rootScope.response.error = false;
    };
    $rootScope.ShowIconSuccess = function () {
        $rootScope.response.loading = false;
        $rootScope.response.success = true;
        $rootScope.response.error = false;
        $timeout(function () {
            $rootScope.ShowIconNormal();
        }, 5000);
    };
    $rootScope.ShowIconError = function () {
        $rootScope.response.loading = false;
        $rootScope.response.success = false;
        $rootScope.response.error = true;
    };

    if (!$rootScope.ZoneMenuItemList) {
        UserService.GetZoneMenuItemList()
            .then(function (data) {
                $rootScope.ZoneMenuItemList = data;
                $rootScope.CurrentZone = $rootScope.ZoneMenuItemList[0];
                $rootScope.DefaultGlobalZoneId = $rootScope.CurrentZone.ZoneId;
                $rootScope.CurrentZoneId = $rootScope.DefaultGlobalZoneId;
                if ($scope.ParamZoneId == undefined) {
                    $scope.ParamZoneId = $rootScope.DefaultGlobalZoneId;
                }
            });
    }

    $rootScope.LayoutWithSearch = false;
    $rootScope.LayoutCurrentZoneTitle = 'guides';

    $scope.getZoneData = function (id, lang) {
        if (id === undefined) {
            id = 1;

        }
        UserService.GetZone(id, lang)
            .then(function (zone) {
                $scope.LeftMenu = zone.RubricList;
                // [Lam Hong 12-Sep-2025] LVCG-200: [LEFT NAVIGATION MENU] Display GUIDE rubrics if they are activated in ZONELINK
                $scope.LeftMenuParent = zone.RubricParentGroup;
                $scope.LeftMenu24h = zone.RubricList.filter(e => e.ParentRubricId == 300);
                $scope.LeftMenuItinary = zone.RubricList.filter(e => e.ParentRubricId == 400);
                $scope.LeftMenuHistoire = zone.RubricList.filter(e => e.ParentRubricId == 2300);
                $rootScope.CurrentZoneVm = zone;
                if ($stateParams.z) {
                    $rootScope.LayoutCurrentZoneTitle = $rootScope.CurrentZoneVm.ZoneTitle;
                }
            });
    }

    $rootScope.UpdateRoles = function () {
        $rootScope.EnumRole = globalEnumRole;
        $rootScope.RoleForPagesConsultation = globalRoleForPagesConsultation;
        $rootScope.RoleForPagesCorrection = globalRoleForPagesCorrection;
        $rootScope.RoleForPagesTranslation = globalRoleForPagesTranslation;
        $rootScope.RoleForPagesCreation = globalRoleForPagesCreation;
        $rootScope.RoleForPagesAdmin = globalRoleForPagesAdmin;
        $rootScope.RoleForDownload = globalRoleForDownload;
        $rootScope.RoleForResendMailWelcome = globalRoleForResendMailWelcome;
        $rootScope.RoleForDragAndDropPosition = globalRoleForDragAndDropPosition;
    }
    $rootScope.UpdateRoles();

    if ($stateParams.z) {
        $scope.ParamZoneId = $stateParams.z;
    }
    else {
        $scope.ParamZoneId = $rootScope.DefaultGlobalZoneId;

    }

    $scope.getZoneData($stateParams.z, $rootScope.LangForInterface);




    //Characters count = Length limit - actual length
    $rootScope.ckEditorWarningCount = 10;
    $rootScope.ckEditorDangerCount = 5;

    $scope.getWordCount = function (text) {
        var s = text ? text.split(/\s+/) : 0;
        return s ? s.length : '';
    };

    $scope.getCkEditorPlainWordCount = function (ckEditorId) {
        myCkEditor = CKEDITOR.instances[ckEditorId];
        if (myCkEditor != undefined) {
            if (myCkEditor.document != undefined) {
                if (myCkEditor.document.getBody() != undefined && myCkEditor.document.getBody().$ != undefined) {
                    if (myCkEditor.document.getBody().getText() != undefined) {
                        return $scope.getPlainWordCount(myCkEditor.document.getBody().getText());
                    }
                }
            }
        }
        return 0;
    };

    $scope.getCkEditorPlainCharCount = function (ckEditorId) {
        myCkEditor = CKEDITOR.instances[ckEditorId];
        if (myCkEditor != undefined) {
            if (myCkEditor.document != undefined) {
                if (myCkEditor.document.getBody() != undefined && myCkEditor.document.getBody().$ != undefined) {
                    if (myCkEditor.document.getBody().getText() != undefined) {
                        return myCkEditor.document.getBody().getText().length;
                    }
                }
            }
        }
        return 0;
    };

    $scope.getPlainWordCount = function (textWithHTML) {
        var plainText = '';
        if (textWithHTML != undefined) {
            plainText = textWithHTML.replace(/<\/?[^>]+(>|$)/g, "").replaceAll('&nbsp;', ' ');
        }
        var s = plainText ? plainText.split(/\s+/) : 0;
        return s ? s.length : 0;
    };

    $scope.getPlainCharCount = function (textWithHTML) {
        if (textWithHTML != undefined) {
            plainText = textWithHTML.replace(/<\/?[^>]+(>|$)/g, "").replaceAll('&nbsp;', ' ');
            return plainText.length;
        }
    };

    $rootScope.CheckDescriptionLengthLimitForObject = function (ParentQcId) {
        //Parent QC and length limit for description                       
        ParentQcId = parseInt(ParentQcId);
        switch (ParentQcId) {
            //Itinerary
            case 6560:
                $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary = $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary6560;
                break;
            case 10588:
                $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary = $rootScope.AdminConfiguration.LengthLimitOfDescInItinerary10588;
                break;
            //Group
            case 10585:
                $rootScope.AdminConfiguration.LengthLimitOfDescInGroup = $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10585;
                break;
            case 10584:
                $rootScope.AdminConfiguration.LengthLimitOfDescInGroup = $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10584;
                break;
            case 10586:
                $rootScope.AdminConfiguration.LengthLimitOfDescInGroup = $rootScope.AdminConfiguration.LengthLimitOfDescInGroup10586;
                break;
            default:
                break;
        }
    }

    //Global Variable for SideBar

    $rootScope.ClassificationList = [];
    $rootScope.DistrictList = [];
    $rootScope.PlaceList = [];
    $rootScope.CurrentObjectId = '';
    $rootScope.CurrentPageType = '';
    $rootScope.CurrentObjectStatus = '';
    $rootScope.UpdateObjectStatus = '';
    $rootScope.TranslateDescription = '';
    $rootScope.PlaceParent = '';
    $rootScope.Classifications = [];
    $rootScope.Comments = [];
    $rootScope.SideBar = {};
    $rootScope.AddComment = {};
    $rootScope.SaveContact = {};
    $rootScope.SaveDiffuseur = {};
    $rootScope.SaveAdressesAssociees = {};
    $rootScope.SaveClassification = {};
    $rootScope.Clients = [];
    $rootScope.placevm = {};
    $rootScope.vm = {};
    $rootScope.vmcreationstep = 0;
    $rootScope.nextstep = "";
    $rootScope.prevstep = "";
    $rootScope.total_count = 0;
    $rootScope.AdvancedSearch = {};
    $rootScope.GlobalAdvancedSearch = {};
    $rootScope.SelectedListId = {};
    $rootScope.SelectedListId.place = [];
    $rootScope.SelectedListId.set = [];
    $rootScope.SelectedListId.itinerary = [];
    $rootScope.SelectedListId.bio = [];
    $rootScope.SelectedListId.district = [];
    $rootScope.SelectedListId.walk = [];
    $rootScope.SideBarSearchVM = {
        GlobalSearch: {
            SearchValues: [],
            Keyword: ''
        }
    };
    $rootScope.UserInfos = {};
    $rootScope.ZoneInfos = {};

    $scope.tags = ['Restaurant', 'Charme', 'Grande table'];
    //Global constants
    $rootScope.EnumLinkType = {
        City: 10,
        Place: 12,
        Itinerary: 15,
        District: 16,
        Group: 17,
        Bio: 59,
        Client: 60,
        Zone: 81
    }
    //$scope.ChangeZone = function (zone) {
    //    $rootScope.CurrentZone = zone;
    //}

    $scope.ChangeZoneById = function (zoneId) {
        zoneList = $rootScope.ZoneMenuItemList;
        if (zoneList != undefined) {
            for (var i = 0; i < zoneList.length; i++) {
                if (zoneList[i].ZoneId == zoneId) {
                    $rootScope.CurrentZone = zoneList[i];
                    $rootScope.LayoutCurrentZoneTitle = $rootScope.CurrentZone.ZoneTitle;
                    break;
                }
            }
        }
    }

    $rootScope.LogInFailed = false;
    /**
     * function for removeTags
     * @method
     * @return {[type]} [description]
     */
    $rootScope.removeTags = function (key) {
        $rootScope.SideBarSearchVM.GlobalSearch.SearchValues.splice(key, 1);
        $rootScope.$apply();
    };


    $scope.$on(
        '$viewContentLoaded',
        function () {
            menu();
        }
    );

    angular.element($window).bind(
        'resize', function () {
            $scope.$emit('windowResize');
        }
    );

    $rootScope.LogMeOut = function () {
        AuthenticationService.Logout();
    }

    $rootScope.CreateNewObject = function (typeObject, typeObjectParam, $event) {
        switch (typeObject) {
            case 'place':
                //typeObjectParam = MCD
                $state.go('app.creationPlace.name', { mcd: typeObjectParam }, { reload: true });
                $event.stopPropagation();
                $event.preventDefault();
                break;
            case 'bio':
                $state.go('app.creationGuest.biographie', { qc: typeObjectParam }, { reload: true });
                $event.stopPropagation();
                $event.preventDefault();
                break;
            case 'group':
                //typeObjectParam = QC
                $state.go('app.creationSet.new', { qc: typeObjectParam }, { reload: true });
                $event.stopPropagation();
                $event.preventDefault();
                break;
            case 'itinerary':
                //typeObjectParam = QC
                $state.go('app.creationItinerary.name', { qc: typeObjectParam }, { reload: true });
                $event.stopPropagation();
                $event.preventDefault();
                break;
            case 'district':
                $state.go('app.creationDistrict.new');
                $event.stopPropagation();
                $event.preventDefault();
                break;
            default:
                break;
        }
    }


    var writer = new CKEDITOR.htmlWriter;

    // The character sequence to be used for line breaks.
    writer.lineBreakChars = '';

    // The writing rules for the <p> tag.
    writer.setRules('p', {
        // Indicates that this tag causes indentation on line breaks inside of it.
        indent: false,

        // Inserts a line break before the <p> opening tag.
        breakBeforeOpen: false,

        // Inserts a line break after the <p> opening tag.
        breakAfterOpen: false,

        // Inserts a line break before the </p> closing tag.
        breakBeforeClose: false,

        // Inserts a line break after the </p> closing tag.
        breakAfterClose: true
    });



    $scope.ckOptionsEditCrea = {
        language: 'fr',
        allowedContent: true,
        disableNativeSpellChecker: false,
        entities: false,
        basicEntities: false,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Subscript', 'Superscript', 'Format', 'Styles']
            },
            {
                name: 'clipboard',
                items: ['Cut', 'Copy', 'Paste', 'PasteText', 'Undo', 'Redo']
            },
            {
                name: 'link',
                items: ['Link']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: '',

        extraPlugins: 'preview',
        removePlugins: 'liststyle,tabletools,scayt,menubutton,contextmenu',
        stylesSet: 'attributeStyleSet',
        //contentsCss: 'www/assets/css/main.css',
        indentationChars: '',
        lineBreakChars: '',
        p: {
            indent: false,
            breakAfterOpen: false,
            breakBeforeOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false
        }
    };

    $scope.profilMenu = false;
    var firstCallProfilMenu = null;
    var forcingClick = false;
    $scope.triggerProfilMenuFocus = function () {
        if (forcingClick == true) { $scope.profilMenu = false; forcingClick = false; return false; }
        $scope.profilMenu = !$scope.profilMenu;
        if ($scope.profilMenu == true) {
            setTimeout(function () {
                document.getElementById('profile-submenu').focus();
            }, 200);
        }
        if (firstCallProfilMenu == null) {
            firstCallProfilMenu = true;
        }
        else {
            firstCallProfilMenu = false;
        }
        if (firstCallProfilMenu == true) {
            $('#profile-submenu').bind('focusout', function (e) {
                var pfsParent = $(e.relatedTarget).parents('#profile-submenu');
                if (pfsParent.length <= 0) {
                    $('#profile-menu-btn').click();
                    forcingClick = true;
                    setTimeout(function () {
                        forcingClick = false;
                    }, 200);
                }
            });
        }
    };
    $scope.triggerSearchFocus = function () {
        setTimeout(function () {
            angular.element('#search-block')[0].focus();
        }, 200);
    }

    $scope.toggleAll = function (dataList, isAllSelected) {
        angular.forEach(dataList, function (itm) {
            itm.selected = isAllSelected;
        });
    }

    $scope.toggleAllSelectedId = function (dataList, isAllSelected, type) {
        angular.forEach(dataList, function (itm) {
            if (!(itm.selected && isAllSelected))
                $scope.toggleListSelectedId(itm, isAllSelected, type);
        });
    }

    $scope.optionToggled = function (dataList, vm) {
        vm.isAllSelected = dataList.every(function (itm) {
            return itm.selected;
        });
    }
    $scope.toggleListSelectedId = function (item, checked, type) {
        var index = $rootScope.SelectedListId[type].indexOf(item.Id);
        if (index !== -1) {
            if (!checked)
                $rootScope.SelectedListId[type].splice(index, 1);
            else
                $rootScope.SelectedListId[type].push(item.Id);
        }
        else
            $rootScope.SelectedListId[type].push(item.Id);

    }

    $rootScope.resetSelectedListId = function () {
        $rootScope.SelectedListId.place = [];
        $rootScope.SelectedListId.set = [];
        $rootScope.SelectedListId.itinerary = [];
        $rootScope.SelectedListId.bio = [];
        $rootScope.SelectedListId.district = [];
        $rootScope.SelectedListId.walk = [];
    }
    $rootScope.InitListSelectedId = function (dataList, type, vm) {

        vm.isAllSelected = true;
        angular.forEach(dataList, function (itm) {
            var index = $rootScope.SelectedListId[type].indexOf(itm.Id);
            if (index !== -1)
                itm.selected = true;
            else
                vm.isAllSelected = false;
        });


    }

    function getAllIndexes(arr, val) {
        var indexes = [], i = -1;
        while ((i = arr.indexOf(val, i + 1)) != -1) {
            indexes.push(i);
        }
        return indexes;
    }
    //partage par mail
    $rootScope.shareInfoByDefaultMail = function (objectType, emailText, object) {
        maxEmailUrlLength = 1900;
        var linebreak = '\n';
        switch (objectType) {
            case 'emailSharePlacePracticalInfo':
                finalEmailText = angular.copy(emailText);

                finalEmailText = finalEmailText.replaceAll('{PlaceTitle}', object.CurrentPlaceTranslation.PlaceTitle);
                finalEmailText = finalEmailText.replace('{OriginalTitle}', object.CurrentPlace.OriginalTitle);
                finalEmailText = finalEmailText.replace('{Address}', object.CurrentPlaceTranslation.AddressLine);
                finalEmailText = finalEmailText.replace('{Transport}', object.CurrentPlaceTranslation.TransportInfo);
                finalEmailText = finalEmailText.replace('{Telephone}', (object.CurrentPlace.Tel + ' ' + object.CurrentPlace.Tel2 + ' ' + object.CurrentPlace.Tel3).replaceAll('null', ''));
                finalEmailText = finalEmailText.replace('{Fax}', (object.CurrentPlace.Fax + ' ' + object.CurrentPlace.Fax2 + ' ' + object.CurrentPlace.Fax3).replaceAll('null', ''));
                finalEmailText = finalEmailText.replace('{Website}', (object.CurrentPlace.Website + ' ').replaceAll('null', ''));
                finalEmailText = finalEmailText.replace('{InfosComplementaires}', object.CurrentPlaceTranslation.PracticalInfo);
                finalEmailText = finalEmailText.replace('{Tarif}', (object.CurrentPlaceTranslation.PriceInfo + ' ').replaceAll('null', ''));
                finalEmailText = finalEmailText;
                window.location.href = finalEmailText;
                break;
            case 'emailShareBioPracticalInfo':
                finalEmailText = angular.copy(emailText);
                finalEmailText = finalEmailText.replaceAll('{LastName}', object.Bio.LastName);
                finalEmailText = finalEmailText.replace('{FirstName}', object.Bio.FirstName);
                finalEmailText = finalEmailText.replace('{NickName}', object.Bio.NickName);
                //description list
                descList = object.DescriptionList;
                descText = linebreak;
                for (var i = 0; i < descList.length; i++) {
                    if (finalEmailText.length + encodeURIComponent(descText).length + encodeURIComponent((i + 1).toString() + ' : ' + descList[i].Stick + linebreak).length < maxEmailUrlLength) {
                        descText += (i + 1).toString() + ' : ' + descList[i].Stick + linebreak;
                    }
                }
                if (finalEmailText.length + encodeURIComponent(descText).length < maxEmailUrlLength) {
                    descText = encodeURIComponent(descText);
                    finalEmailText = finalEmailText.replace('{Descriptions}', descText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Descriptions}', '');
                }

                //associated place list
                placeList = $rootScope.AssociatedPlaces;
                placeText = linebreak;
                placeOrder = 1;
                for (var i = 0; i < placeList.length; i++) {

                    if (placeList[i].actif == true) {
                        if (finalEmailText.length + encodeURIComponent(placeText).length + encodeURIComponent(placeOrder.toString() + ' : ' + placeList[i].name + linebreak).length < maxEmailUrlLength) {
                            placeText += placeOrder.toString() + ' : ' + placeList[i].name + linebreak;
                            console.log(finalEmailText.length + encodeURIComponent(placeText).length);
                        }
                        ++placeOrder;
                    }
                }
                if (finalEmailText.length + encodeURIComponent(placeText).length < maxEmailUrlLength) {
                    placeText = encodeURIComponent(placeText);
                    finalEmailText = finalEmailText.replace('{Places}', placeText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Places}', '');
                }

                window.location.href = finalEmailText;
                break;

            case 'emailShareGroupPracticalInfo':
                finalEmailText = angular.copy(emailText);
                finalEmailText = finalEmailText.replaceAll('{GroupTitle}', object.GroupTrans.GroupTitle);
                finalEmailText = finalEmailText.replace('{ShortTitle}', object.GroupTrans.GroupShortTitle);
                descList = object.DescriptionList;

                descText = linebreak;
                for (var i = 0; i < descList.length; i++) {
                    descText += (i + 1).toString() + ' : ' + descList[i].DescriptionTitle + linebreak;
                }
                if (finalEmailText.length + encodeURIComponent(descText).length < maxEmailUrlLength) {
                    descText = encodeURIComponent(descText);
                    finalEmailText = finalEmailText.replace('{Descriptions}', descText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Descriptions}', '');
                }

                //associated place list
                placeList = $rootScope.AssociatedPlaces;
                placeText = linebreak;
                placeOrder = 1;
                for (var i = 0; i < placeList.length; i++) {

                    if (placeList[i].actif == true) {
                        placeText += placeOrder.toString() + ' : ' + placeList[i].name + linebreak;
                        ++placeOrder;
                    }
                }
                if (finalEmailText.length + encodeURIComponent(descText).length < maxEmailUrlLength) {
                    placeText = encodeURIComponent(placeText);
                    console.log(placeText.replaceAll('&', '-'));
                    finalEmailText = finalEmailText.replace('{Places}', placeText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Places}', '');
                }
                window.location.href = finalEmailText;
                break;

            case 'emailShareDistrictPracticalInfo':
                finalEmailText = angular.copy(emailText);
                finalEmailText = finalEmailText.replaceAll('{DistrictTitle}', object.CurrentDisctrict.DistrictTitle);
                finalEmailText = finalEmailText.replace('{DistrictSubTitle}', object.CurrentDisctrict.DistrictSubTitle);

                //description list
                descList = object.DescriptionList;
                descText = linebreak;
                for (var i = 0; i < descList.length; i++) {
                    descText += (i + 1).toString() + ' : ' + descList[i].Description.DescriptionTitle + ' - ' + descList[i].Description.Resume + linebreak;
                }
                if (finalEmailText.length + encodeURIComponent(descText).length < maxEmailUrlLength) {
                    descText = encodeURIComponent(descText);
                    finalEmailText = finalEmailText.replace('{Descriptions}', descText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Descriptions}', '');
                }
                //associated place list
                placeList = object.PlaceList;
                placeText = linebreak;
                placeOrder = 1;
                for (var i = 0; i < placeList.length; i++) {

                    if (placeList[i].actif == true) {
                        if (finalEmailText.length + encodeURIComponent(placeText).length + encodeURIComponent(placeOrder.toString() + ' : ' + placeList[i].name + linebreak).length < maxEmailUrlLength) {
                            placeText += placeOrder.toString() + ' : ' + placeList[i].name + linebreak;
                        }
                        ++placeOrder;
                    }
                }
                if (finalEmailText.length + encodeURIComponent(placeText).length < maxEmailUrlLength) {
                    placeText = encodeURIComponent(placeText);
                    finalEmailText = finalEmailText.replace('{Places}', placeText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Places}', '');
                }
                window.location.href = finalEmailText;
                break;


            case 'emailShareItineraryPracticalInfo':
                finalEmailText = angular.copy(emailText);
                finalEmailText = finalEmailText.replaceAll('{ItineraryTitle}', object.Iti.ItineraryTranslationList[0].ItineraryTitle);
                finalEmailText = finalEmailText.replace('{SubTitle}', object.Iti.ItineraryTranslationList[0].SubTitle);

                //description list
                descList = object.DescriptionList;
                descText = linebreak;
                for (var i = 0; i < descList.length; i++) {
                    descText += (i + 1).toString() + ' : ' + descList[i].Description.DescriptionTitle + ' - ' + descList[i].Description.Resume + linebreak;
                }
                if (finalEmailText.length + encodeURIComponent(descText).length < maxEmailUrlLength) {
                    descText = encodeURIComponent(descText);
                    finalEmailText = finalEmailText.replace('{Descriptions}', descText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Descriptions}', '');
                }

                //associated place list
                placeList = $rootScope.PlaceList;
                placeText = linebreak;
                placeOrder = 1;
                for (var i = 0; i < placeList.length; i++) {

                    if (placeList[i].actif == true) {
                        if (finalEmailText.length + encodeURIComponent(placeText).length + encodeURIComponent(placeOrder.toString() + ' : ' + placeList[i].name + linebreak).length < maxEmailUrlLength) {
                            placeText += placeOrder.toString() + ' : ' + placeList[i].name + linebreak;
                        }
                        ++placeOrder;
                    }
                }
                if (finalEmailText.length + encodeURIComponent(placeText).length < maxEmailUrlLength) {
                    placeText = encodeURIComponent(placeText);
                    finalEmailText = finalEmailText.replace('{Places}', placeText);
                }
                else {
                    finalEmailText = finalEmailText.replace('{Places}', '');
                }
                window.location.href = finalEmailText;
                break;
            default:

        }
    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.modalError = false;
    $scope.modalSuccess = false;

    $scope.openModal = function (callback) {
        if (callback === "error") {
            $scope.modalError = true;
            $scope.modalSuccess = false;
        } else if (callback === "success") {
            $scope.modalError = false;
            $scope.modalSuccess = true;
        }
    };

    $scope.scrollLeftInd = 0;

    var scrollHorizontal = function ($event, direction, nbScroll) {
        var parent = $($event.target).closest('.systeme_onglets'),
            onglets = parent.find('.onglets-container'),
            current = onglets.scrollLeft();
        if (direction == 'right') {
            $scope.scrollLeftInd = current + 300;
        } else {
            $scope.scrollLeftInd = current - 300;
        }
        $(onglets).animate({
            scrollLeft: $scope.scrollLeftInd
        }, 300);

    };

    $scope.scrollToLeft = function ($event) {
        scrollHorizontal($event, 'left');
    };

    $scope.scrollToRight = function ($event) {
        scrollHorizontal($event, 'right');
    };

    $scope.openShareStatus = false;

    $scope.openShare = function (title) {
        $scope.openShareStatus = true;
        $scope.title = title;
    };

    $scope.closeModalShare = function () {
        $scope.openShareStatus = false;
    };

    $scope.openEmailVerification = function () {
        if ($rootScope.SideBar.AssociatedContacts.ContactList.length > 0) {
            //Email verification
            $scope.openVerificationEmailConfirmation = true;

            $scope.EmailVerificationCivilitePrenomNom = $rootScope.SideBar.AssociatedContacts.ContactList[0].Contact.LastName + ' ' + $rootScope.SideBar.AssociatedContacts.ContactList[0].Contact.FirstName;
            $scope.EmailVerificationContactEmail = $rootScope.SideBar.AssociatedContacts.ContactList[0].Contact.Email;
        }
        else {
            //console.log("No contact list");
            alert("No contact associated to this place!");
        }

    }

    $scope.closeEmailVerification = function () {
        //Email verification
        $scope.openVerificationEmailConfirmation = false;
    }

    $scope.copyStringToClipboard = function (string) {
        function handler(event) {
            event.clipboardData.setData('text/plain', string);
            event.preventDefault();
            document.removeEventListener('copy', handler, true);
        }

        document.addEventListener('copy', handler, true);
        document.execCommand('copy');
    }

    $rootScope.isChecked = function () {
        //var qualification = filterFilter($scope.criteres.qualification, { checked: true }).length > 0;
        //var statut = filterFilter($scope.criteres.statut, { checked: true }).length > 0;

        var Editorial = false;
        var Rubric = false;
        var SubRubric = false;
        var Typology = false;
        var ServiceEquipement = false;
        var CityListSelect = false;
        var StatusList = false;
        var Client = false;
        var AuthorList = false;
        var TranslatorList = false;
        var CorrectorList = false;
        var LangList = false;
        var nouveaute = false;
        var historique = false;
        var invite = false;
        var datecreation = false;
        var datemofdification = false;
        if ($rootScope.SideBarSearchVM) {
            if ($rootScope.SideBarSearchVM.ClassificationList) {
                Editorial = filterFilter($rootScope.SideBarSearchVM.ClassificationList.Editorial, { actif: true }).length > 0;
                Rubric = filterFilter($rootScope.SideBarSearchVM.ClassificationList.Rubric, { actif: true }).length > 0;
                SubRubric = filterFilter($rootScope.SideBarSearchVM.ClassificationList.SubRubric, { actif: true }).length > 0;
                Typology = filterFilter($rootScope.SideBarSearchVM.ClassificationList.Typology, { actif: true }).length > 0;
                ServiceEquipement = filterFilter($rootScope.SideBarSearchVM.ClassificationList.ServiceEquipement, { actif: true }).length > 0;
            }
            if ($rootScope.SideBarSearchVM.CityListSelect)
                CityListSelect = filterFilter($rootScope.SideBarSearchVM.CityListSelect, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.StatusList)
                StatusList = filterFilter($rootScope.SideBarSearchVM.StatusList, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.Client)
                Client = filterFilter($rootScope.SideBarSearchVM.Client, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.AuthorList)
                AuthorList = filterFilter($rootScope.SideBarSearchVM.AuthorList, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.TranslatorList)
                TranslatorList = filterFilter($rootScope.SideBarSearchVM.TranslatorList, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.CorrectorList)
                CorrectorList = filterFilter($rootScope.SideBarSearchVM.CorrectorList, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.LangList)
                LangList = filterFilter($rootScope.SideBarSearchVM.LangList, { actif: true }).length > 0;
            if ($rootScope.SideBarSearchVM.IsNew)
                nouveaute = $rootScope.SideBarSearchVM.IsNew;
            if ($rootScope.SideBarSearchVM.Priority)
                historique = $rootScope.SideBarSearchVM.Priority;
            if ($rootScope.SideBarSearchVM.WithBio)
                invite = $rootScope.SideBarSearchVM.WithBio;
            if ($rootScope.SideBarSearchVM.CreationDate)
                datecreation = $rootScope.SideBarSearchVM.CreationDate.value;
            if ($rootScope.SideBarSearchVM.UpdateDate)
                datemofdification = $rootScope.SideBarSearchVM.UpdateDate.value;

        }
        //if (qualification || diffuseur || redacteur || correcteur || statut || traducteur || auteur || langue || nouveaute || historique || invite || datecreation || datemofdification || datemaj) {
        //    return true;
        //

        if (datecreation || datemofdification || nouveaute || historique || invite || LangList || CorrectorList || TranslatorList || AuthorList || Client || StatusList || CityListSelect || ServiceEquipement || Typology || SubRubric || Editorial) {
            return true;

        }
    };

    /**
     * Reset champs
     */
    $rootScope.ResetChamps = function () {
        var tab = ['LangList', 'CorrectorList', 'TranslatorList', 'AuthorList', 'Client', 'StatusList', 'CityListSelect'];
        tab.forEach(function (item) {
            if (filterFilter($rootScope.SideBarSearchVM[item], { actif: true }).length > 0) {
                $rootScope.SideBarSearchVM[item].forEach(function (item) {
                    item.actif = false;
                });
                //   $rootScope.$broadcast('resetSelectMultiple', $rootScope.SideBarSearchVM[item]); // broadcast
            }
        });
        var tab = ['ServiceEquipement', 'Typology', 'SubRubric', 'Editorial', 'Rubric'];
        if ($rootScope.SideBarSearchVM.ClassificationList) {
            tab.forEach(function (item) {
                if (filterFilter($rootScope.SideBarSearchVM.ClassificationList[item], { actif: true }).length > 0) {
                    $rootScope.SideBarSearchVM.ClassificationList[item].forEach(function (item) {
                        item.actif = false;
                    });
                    // $rootScope.$broadcast('resetSelectMultiple', $rootScope.SideBarSearchVM.ClassificationList[item]); // broadcast
                }
            });
        }


        //$rootScope.SideBarSearchVM.CreationDate.value = "";
        //$rootScope.SideBarSearchVM.UpdateDate.value = "";


        // $rootScope.$broadcast('resetDate', true); // broadcast


        $rootScope.SideBarSearchVM.IsNew = false;
        $rootScope.SideBarSearchVM.Priority = false;
        $rootScope.SideBarSearchVM.WithBio = false;

        if ($rootScope.SideBarSearchVM.slider) {
            $rootScope.SideBarSearchVM.slider[0].min = 0;
            $rootScope.SideBarSearchVM.slider[0].max = 1000;

            $rootScope.SideBarSearchVM.slider[1].min = 0;
            $rootScope.SideBarSearchVM.slider[1].max = 24;
        }

    };

    /**
	 * function for removeTagsMultiple
	 * @method
	 * @return {[type]} [description]
	 */
    $scope.removeTagsMultiple = function (item) {
        item.actif = false;
    };

    //// All the informations for display tag in the search box.
    $scope.tags = {
        list: [],
        selected: -1,
        removeTags: function (key) {
            $scope.tags.list.splice(key, 1);
        },
    };

    $rootScope.countSelectedSearchTags = function () {
        var count = 0;
        $scope.tags.list = [];
        for (var property in $rootScope.SideBarSearchVM.GlobalSearch.SearchValues) {
            if ($rootScope.SideBarSearchVM.GlobalSearch.SearchValues.hasOwnProperty(property)) {
                var ss = { "key": property, "value": angular.copy($rootScope.SideBarSearchVM.GlobalSearch.SearchValues[property]) };
                $scope.tags.list.push(ss)
                count++;
            }
        }
        return count;
    }

    // All the informations about the search box
    $scope.searchBox = {
        $input: $('.search-input')[0],
        $headerBloc: $('.header-search-block')[0],
        isOpen: false,
        inputValue: $rootScope.SideBarSearchVM.GlobalSearch.Keyword,
        open: function () {
            $scope.searchBox.isOpen = true;
            $scope.tags.selected = -1;
        },
        close: function () {
            $scope.searchBox.isOpen = false;
            //$scope.searchBox.inputValue = '';
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = '';
        },
        inputChange: function () {
            //console.log("inputChange");
            if (!$scope.searchBox.isOpen && 0 < $rootScope.SideBarSearchVM.GlobalSearch.Keyword.length) {
                $scope.searchBox.open();
            }
            else if ($scope.searchBox.isOpen && $rootScope.SideBarSearchVM.GlobalSearch.Keyword.length == 0) {
                $scope.searchBox.close();
            }
        },
        keyDown: function ($event) {
            //console.log('event', $event.which, $rootScope.SideBarSearchVM.GlobalSearch.Keyword, $event);
            if ('' === $rootScope.SideBarSearchVM.GlobalSearch.Keyword || $rootScope.SideBarSearchVM.GlobalSearch.Keyword == null) {
                if (8 === $event.which) {

                    if (-1 === $scope.tags.selected) {


                        $scope.tags.selected = $rootScope.countSelectedSearchTags() - 1;
                    } else {
                        $rootScope.removeTags($scope.tags.list[$scope.tags.selected].key);
                        $scope.tags.removeTags($scope.tags.selected);
                        $scope.tags.selected = $scope.tags.list.length - 1;
                        //$scope.tags.selected = $rootScope.countSelectedSearchTags() - 1;
                    }
                }
            }

        },
        search: function (value, column) {
            // We add the tag for display.
            //$scope.tags.addTags(column);
            // We close the box.
            $scope.searchBox.close();
            // The API call should be there.
            $rootScope.resetSelectedListId();
            $rootScope.GlobalAdvancedSearch(column, value);
        },
        blur: function ($event) {
            // if we focus on the input we don't close the bloc
            if ($scope.searchBox.$input == $event.relatedTarget) {
                return;
            }
            // if we focus on the block we don't close the bloc
            if ($scope.searchBox.$headerBloc == $event.relatedTarget) {
                return;
            }
            $scope.searchBox.close();
        }
    };

    $rootScope.getJobList = function () {
        if ($rootScope.ProfessionList == undefined) {
            HelperService.GetProfessionList().
                then(function success(data) {
                    for (var i = 0; i < data.length; i++) {
                        data[i].DisplayedTitle = data[i].IsMale ? (data[i].ProfessionTitle + " - " + $translate.instant("maleJob")) : (data[i].ProfessionTitle + " - " + $translate.instant("femaleJob"));

                    }
                    $rootScope.ProfessionList = data;
                },
                    function error(data) { }
                );
        }
    }

    $rootScope.getChildQcOfSelectedParent = function (allQcList, selectedParentQc) {
        var result = [];
        for (var k = 0; k < selectedParentQc.length; k++) {
            if (selectedParentQc[k].actif == true) {
                for (var i = 0; i < allQcList.length; i++) {
                    if (allQcList[i]["qcParentId"] == selectedParentQc[k]["qcId"]) {
                        result.push(allQcList[i]);
                    }
                }
            }
        }
        return result;
    }

    $rootScope.CheckMaxPlaceNumber = function (CurrentPlaceNumberOfZone, MaxPlaceNumberOfZone) {
        var msg = $translate.instant("maxPlaceNumberMessage");
        if (CurrentPlaceNumberOfZone > MaxPlaceNumberOfZone) {
            toastr.clear();
            toastr.warning(msg.format($rootScope.globals.currentUser.FullName, MaxPlaceNumberOfZone));
        }
    }

    // [Lam Hong 12-Sep-2025] LVCG-200: [LEFT NAVIGATION MENU] Display GUIDE rubrics if they are activated in ZONELINK
    $rootScope.ShowRubricKeyWordById = function (rubricId) {
        // var rubricTitle = rubric.RubricTitle;
        if (rubricId < 0) {
            return '';
        } else if (rubricId == 110) {
            return 'hotels';
        } else if (rubricId == 120) {
            return 'restaurants';
        } else if (rubricId == 130) {
            return 'bonnesChosesPetitesFaims';
        } else if (rubricId == 140) {
            return 'barCafesSalonsThe';
        } else if (rubricId == 150) {
            return 'nuits';
        } else if (rubricId == 160) {
            return 'affairesStyle';
        } else if (rubricId == 170) {
            return 'objetsQualite';
        } else if (rubricId == 180) {
            return 'artsCultures';
        } else if (rubricId == 110) {
            return 'laVilleModeEmploi';
        } else {
            return rubricTitle;
        }
    }
}


